<script>
  import { onMount } from "svelte";
  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  let table = null;
  let loading = false;
  let nextPageToken = null;
  let tableData = {
    columns: [
      { key: "name", label: M.NAME, class: "flex-1 mw-240" },
      { key: "email", label: M.EMAIL, class: "flex-none" },
      {
        key: "open",
        label: M.OPENED,
        type: "number",
        rowClass: "pay-status paid",
        class: "flex-none mw-140"
      },
      {
        key: "click",
        label: M.CLICKED,
        type: "number",
        rowClass: "order-status pending",
        class: "flex-none mw-140"
      }
      //     { key: "sales", label: M.SALES, class: "flex-none mw-140" }
    ],
    rows: []
  };

  let getNextPage = function () {
    if (nextPageToken) {
      load();
    }
  };

  let load = () => {
    const id = External.WebPlatform.getUrlQueryParameter(window.location.href, "id");

    if (!id || loading) {
      return;
    }
    loading = true;
    External.Tools.makeWebsiteRequest({
      action: "getCampaignUnsubscribeStats",
      data: {
        campaignId: id,
        token: nextPageToken ? JSON.stringify(nextPageToken) : null
      },
      onOk: function (response) {
        let data = response.data;
        loading = false;
        if (!data) {
          return;
        }
        nextPageToken = data.nextToken;
        if (table) table.addRows(data.stats);
      }
    });
  };

  let onClick = function (row) {
    External.CPanel.goToUrl("/me/crm/contact/" + row.id, true);
  };

  onMount(load);
</script>

<Table bind:this={table} data={tableData.rows} activeColumns={tableData.columns} onClick={onClick} loading={loading} nextPage={getNextPage} hasSelection={false}>
  <div class="text-center" style="padding: 70px 0;">
    <h5>{M.NO_UNSUBSCRIBED_USERS}</h5>
  </div>
</Table>
